// src/hooks/useFileUpload.ts

import { useState, useContext } from 'react';
import { AxiosContext } from '../contextManager/axios.context';
import { endpoints } from '../constants/endpoints';
import { useToast } from '../contextManager/toast.context';
import { errorMessage } from '../utils';
import useTokenRefresh from './tokenRefresh.service'; // It now gets the hook with both functions


export const useFileUpload = () => {
  const axios = useContext(AxiosContext);
  const { addToast, updateToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const { refreshAccessToken } = useTokenRefresh(); // Get the refresh function

  const uploadFile = async (file: File): Promise<string | null> => {
    setIsLoading(true);
    const toastId = `upload-${Date.now()}`;
    addToast({ id: toastId, variant: 'loading', title: `Uploading ${file.name}...` });

    try {
      const { data: refreshData } = await refreshAccessToken();
      const validToken = refreshData.accessToken;      if (!validToken) throw new Error('Not authenticated');
      if (!validToken) {
        throw new Error('Could not refresh authentication token.');
      }

      const form = new FormData();
      form.append('file', file);

      const { data: uploadData } = await axios.post(endpoints.upload, form, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${validToken}`,
        },
      });

      updateToast(toastId, { variant: 'success', title: 'File uploaded.' });
      return uploadData.url;

    } catch (err: any) {
      const msg = errorMessage(err) || 'File upload failed.';
      updateToast(toastId, { variant: 'error', title: msg });
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { uploadFile, isLoading };
};